import type { VideoMetadata } from '@/lib/video-metadata';
import { isShareImportPlatform } from '@/lib/shareImport/shareImport';

export type UrlVideoValidationError = {
  titleKey: string;
  descriptionKey: string;
  descriptionParams?: Record<string, number>;
};

/** Single source of truth for "can this pasted link become a project/library?".
 *  There is deliberately no minimum length: short videos skip AI curation on
 *  the backend and open straight in the editor. */
export function validateUrlVideoMetadata(
  metadata: VideoMetadata | null,
  { maxDurationSeconds }: { maxDurationSeconds: number },
): UrlVideoValidationError | null {
  if (!metadata || !(metadata.duration > 0)) {
    return { titleKey: 'errors.videoAnalysisError', descriptionKey: 'errors.checkVideoLink' };
  }
  if (metadata.live_status === 'is_live') {
    return { titleKey: 'errors.liveVideo', descriptionKey: 'errors.insertNonLiveVideo' };
  }
  if (metadata.live_status === 'post_live') {
    return { titleKey: 'errors.videoProcessing', descriptionKey: 'errors.videoStillProcessing' };
  }
  if (metadata.live_status === 'is_upcoming') {
    return { titleKey: 'errors.scheduledVideo', descriptionKey: 'errors.insertAvailableVideo' };
  }
  if (!isShareImportPlatform(metadata.platform) && metadata.duration > maxDurationSeconds) {
    return {
      titleKey: 'errors.videoTooLong',
      descriptionKey: 'errors.videoTooLongDescription',
      descriptionParams: { hours: Math.floor(maxDurationSeconds / 3600) },
    };
  }
  return null;
}
